import { P1RegularLink as P1RegularLinkStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P1RegularLink typography style.
 */
export default function P1RegularLink({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P1RegularLinkStyle, sx)} />;
}
